import styles from "./QualityPolicyPage.module.css";

const QualityPolicyPage = () => {
  return (
    <div className={styles.container}>
      <h1>Πoλιτική ποιότητας</h1>
      <p>
        Βασική αρχή και δέσμευση της Εταιρείας{" "}
        <strong>THE RECORDS HUB S.A.</strong> είναι η ικανοποίηση των αναγκών
        και προσδοκιών των πελατών της παρέχοντας τους υπηρεσίες ποιότητας.
      </p>

      <h2>Το πεδίο εφαρμογής της εταιρείας είναι:</h2>
      <ul>
        <li>
          Ασφαλής Ψηφιοποίηση Αρχείων Πελατών της Εταιρείας μας σε Έντυπη Μορφή
        </li>
        <li>
          Ασφαλής Φύλαξη Αρχείων Πελατών της Εταιρείας μας σε Έντυπη ή/και
          Ηλεκτρονική Μορφή
        </li>
        <li>
          Ασφαλής Διαχείριση Αρχείων Πελατών της Εταιρείας μας σε Έντυπη ή/και
          Ηλεκτρονική Μορφή:
          <ul>
            <li>Μεταφορά</li>
            <li>Καταγραφή / Καταλογογράφηση</li>
            <li>Αρχειοθέτηση</li>
            <li>
              Προεπισκόπηση και Αναζήτηση Μεταδεδομένων στη Διαχείριση Αρχείων
            </li>
          </ul>
        </li>
        <li>
          Ασφαλής Καταστροφή Αρχείων Πελατών της Εταιρείας μας σε Έντυπη ή/και
          Ηλεκτρονική Μορφή
        </li>
        <li>
          Συμβουλευτικές Υπηρεσίες για τη Διαχείριση Αρχείων (Records
          Management) Πελατών της Εταιρείας μας
        </li>
        <li>Συμβουλευτικές Υπηρεσίες DPO / GDPR</li>
      </ul>

      <h2>Ο στόχος αυτός είναι συνυφασμένος με:</h2>
      <ul>
        <li>Την πλήρη κατανόηση των απαιτήσεων των πελατών της.</li>
        <li>Την πλήρη κατανόηση των προσδοκιών των ενδιαφερόμενων μερών.</li>
        <li>
          Την προμήθεια των προϊόντων που εμπορεύεται και επεξεργάζεται σύμφωνα
          με τις απαιτήσεις των πελατών.
        </li>
        <li>
          Τις οδηγίες κατασκευαστών και την ισχύουσα νομοθεσία και κανονισμούς.
        </li>
        <li>Την διασφάλιση της Υγείας και της Ασφάλειας στον χώρο Εργασίας.</li>
      </ul>

      <h2>Για να επιτύχει τα πιο πάνω, η Διεύθυνση της εταιρείας:</h2>
      <ul>
        <li>
          Έχει υιοθετήσει Σύστημα Διαχείρισης της Ποιότητας (ΣΔΠ) σύμφωνα με το
          Διεθνές Πρότυπο ΙSO 9001:2015, το οποίο εφαρμόζει σε όλες τις
          δραστηριότητες που έχουν επίπτωση στην ποιότητα των υπηρεσιών της και
          την ικανοποίηση των πελατών της.
        </li>
        <li>
          Ανασκοπεί και βελτιώνει συνεχώς τα χαρακτηριστικά των υπηρεσιών της,
          όπου αυτό είναι εφικτό, καθώς και την αποτελεσματικότητα των
          Διεργασιών της και κατ’ επέκταση ολοκλήρου του ΣΔΠ.
        </li>
        <li>
          Θέτει μετρήσιμους αντικειμενικούς στόχους για την ποιότητα τους
          οποίους αξιολογεί στα πλαίσια της ανασκόπησης του ΣΔΠ.
        </li>
        <li>
          Παρέχει τους απαραίτητους πόρους για την απρόσκοπτη, αποδοτική και
          αποτελεσματική λειτουργία της εταιρείας.
        </li>
        <li>
          Στοχεύει στην ανάπτυξη μακροχρόνιων καλών σχέσεων με αξιόπιστους,
          ποιοτικά και τεχνολογικά αναβαθμισμένους και ευσυνείδητους
          προμηθευτές.
        </li>
        <li>
          Επενδύει στη συνεχή κατάρτιση, ενημέρωση και εκπαίδευση των στελεχών
          της.
        </li>
      </ul>

      <p>
        Η αδιάκοπη προσπάθεια για συνεχή βελτίωση των προϊόντων, υπηρεσιών,
        διεργασιών του ΣΔΠ και η ικανοποίηση των πελατών αποτελεί κύριο μέλημα
        της εταιρείας και φιλοσοφία κάθε στελέχους της.
      </p>
    </div>
  );
};

export default QualityPolicyPage;
